export default "__VITE_ASSET__CnP3p2s1__"